import api from '../api/axios';

export interface PurchaseRequisitionItem {
  id?: number;
  requisition?: number;
  product?: number;
  itemName?: string;
  description?: string;
  quantity: number;
  estimatedPrice?: number;
  tax?: number;
  notes?: string;
}

export interface PurchaseRequisition {
  id?: number;
  requisitionNumber: string;
  requestedBy: number;
  department: number;
  requestDate: string;
  requiredDate?: string;
  status?: 'pending' | 'approved' | 'rejected' | 'ordered' | 'completed';
  notes?: string;
  approvedBy?: number;
  approvalDate?: string;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
}

const PurchaseRequisitionService = {
  getAll: (params?: any) => api.get('/purchase-requisitions', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/purchase-requisitions/${id}`, { 
      params: params || { populate: ['requestedBy', 'department', 'approvedBy'] } 
    }),
  create: (data: PurchaseRequisition) => api.post('/purchase-requisitions', { data }),
  update: (id: number, data: Partial<PurchaseRequisition>) => 
    api.put(`/purchase-requisitions/${id}`, { data }),
  delete: (id: number) => api.delete(`/purchase-requisitions/${id}`),
  
  // Requisition Items
  getItems: (requisitionId: number) =>
    api.get('/purchase-requisition-items', {
      params: {
        'filters[requisition][id][$eq]': requisitionId,
        populate: 'product',
      },
    }),
  createItem: (data: PurchaseRequisitionItem) => api.post('/purchase-requisition-items', { data }),
  updateItem: (id: number, data: Partial<PurchaseRequisitionItem>) =>
    api.put(`/purchase-requisition-items/${id}`, { data }),
  deleteItem: (id: number) => api.delete(`/purchase-requisition-items/${id}`),
};

export default PurchaseRequisitionService;

